/** Human-friendly gallery folder title (sort keys stay on raw `name`). */
export const displayGalleryName = (name) =>
  name.replace(/^\d+\.\s*/, "").replace(/\s+_\s+/g, " / ");
